import { Alert, AlertDescription, chakra } from '@chakra-ui/react';
import React from 'react';

import { useI18n } from 'lib/i18n/context';

const DataFetchAlert = ({ className }: { className?: string }) => {
  const { t } = useI18n();
  return (
    <Alert status="warning" width="fit-content" className={ className }>
      <AlertDescription>
        { t('shared.dataFetchAlert.body') }
      </AlertDescription>
    </Alert>
  );
};

export default chakra(DataFetchAlert);
